import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Ethan Parker",
        title: "Founder & CEO",
        biography: "Ethan Parker is a visionary entrepreneur and the driving force behind AC Rent. With a passion for innovation and excellence, he has built a premier car rental company focused on customer satisfaction and top-tier service.",
        contacts: {
            phone: "555-987-6543",
            email: "e.p@example.com",
            website: "www.acrent.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Business Development",
            "Strategic Planning",
            "Customer Experience Management",
            "Operations & Logistics",
            "Team Leadership"
        ],
        skills: [
            { id: 1, title: "Business Strategy", progress: 98 },
            { id: 2, title: "Leadership", progress: 95 },
            { id: 3, title: "Customer Relations", progress: 90 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Olivia Bennett",
        title: "Operations Manager",
        biography: "Olivia Bennett is an accomplished Operations Manager with a focus on optimizing processes and improving efficiency. She has extensive experience in managing day-to-day operations, overseeing team performance, and ensuring smooth workflows. Olivia’s strategic mindset and attention to detail have contributed to the overall success and growth of the company.",
        contacts: {
            phone: "555-123-4567",
            email: "o.bennett@example.com",
            website: "www.oliviabennettoperations.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Streamlined company processes to increase efficiency",
            "Led cross-functional teams to achieve business objectives",
            "Implemented operational strategies to improve performance",
            "Monitored and optimized inventory management systems",
            "Developed and executed company-wide initiatives"
        ],
        skills: [
            { id: 1, title: "Process Optimization", progress: 92 },
            { id: 2, title: "Team Leadership", progress: 88 },
            { id: 3, title: "Strategic Planning", progress: 90 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Liam Mitchell",
        title: "Fleet Manager",
        biography: "Liam Mitchell is a skilled Fleet Manager with a strong background in vehicle maintenance, logistics, and fleet operations. He is responsible for overseeing the company’s fleet, ensuring all vehicles are well-maintained, and optimizing fleet performance. Liam's proactive approach and organizational skills have been key to maintaining operational efficiency and reducing downtime for the fleet.",
        contacts: {
            phone: "555-345-6789",
            email: "l.mitchell@example.com",
            website: "www.liammitchellfleet.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Managed fleet operations for a large rental company",
            "Ensured regular maintenance and timely repairs for all vehicles",
            "Optimized fleet utilization to reduce operational costs",
            "Implemented vehicle tracking systems for improved efficiency",
            "Developed and managed fleet schedules to maximize availability"
        ],
        skills: [
            { id: 1, title: "Fleet Management", progress: 95 },
            { id: 2, title: "Vehicle Maintenance", progress: 92 },
            { id: 3, title: "Logistics Coordination", progress: 90 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Sophia Carter",
        title: "Customer Support Lead",
        biography: "Sophia Carter is an experienced Customer Support Lead, known for her excellent communication skills and dedication to providing top-tier customer service. With a passion for helping others, she oversees the customer support team, ensuring all clients receive timely and effective assistance. Sophia's problem-solving abilities and commitment to customer satisfaction have helped enhance the company's reputation and foster long-term relationships.",
        contacts: {
            phone: "555-567-8901",
            email: "s.carter@example.com",
            website: "www.sophiacartercustomersupport.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Led a customer support team to deliver exceptional service",
            "Developed and implemented support strategies to improve efficiency",
            "Handled escalated customer issues and provided solutions",
            "Trained and mentored new support staff members",
            "Improved customer satisfaction scores through proactive support"
        ],
        skills: [
            { id: 1, title: "Customer Service", progress: 98 },
            { id: 2, title: "Team Management", progress: 95 },
            { id: 3, title: "Problem Solving", progress: 93 }
        ]
    }

];

export default team;